import React from "react";
import Button from "../Button";
import CloseIcon from "@material-ui/icons/Close";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useStyles } from "./styles";
import { Divider } from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import List from "../List/List";
import { Typography } from "../Typography";
import { Grid } from "../Grid";
import { Popover } from "../Popover";
import Checkbox from "../Checkbox";
import { ListItem } from "../ListItem";
export const SearchInputFilters = props => {
  const {
    filters,
    activeFilters,
    variant,
    onFilterReset
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles(props);
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const filterList = React.useMemo(() => {
    if (!filters) return [];
    return filters.map(props => {
      const value = props.label ? props.label : "";
      return {
        dense: true,
        button: true,
        onClick: () => props.onChange ? props.onChange(value) : undefined,
        itemIcon: /*#__PURE__*/React.createElement(Checkbox, {
          id: props.id,
          color: "primary",
          checked: props.checked,
          tabIndex: -1,
          disableRipple: true,
          inputProps: {
            "aria-labelledby": props.id
          }
        }),
        itemText: {
          id: props.id,
          primary: props.label
        }
      };
    });
  }, [filters]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    flexItem: true,
    orientation: "vertical",
    className: classes.filterDivider
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    type: "icon",
    title: "Search Filters",
    size: variant === "compact" ? "small" : undefined,
    "aria-label": `${activeFilters} active filters`
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: activeFilters,
    color: "primary",
    "data-testid": "filterButton",
    overlap: "rectangular"
  }, /*#__PURE__*/React.createElement(FilterListIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(Popover, {
    title: "Search Filters",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    "data-testid": "filterPopover",
    className: classes.filterPopover
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.searchFilterWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.filterTitleWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.filterTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Filters")), /*#__PURE__*/React.createElement(Button, {
    className: classes.closeButton,
    onClick: handleClose,
    type: "icon",
    size: "small",
    "aria-label": "Close Search Filters"
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    className: classes.filterSelectAll,
    ListItemIconProps: {
      children: /*#__PURE__*/React.createElement(Checkbox, {
        onClick: onFilterReset,
        checked: filters && activeFilters === filters.length,
        color: "primary",
        indeterminate: activeFilters && filters ? activeFilters < filters.length && activeFilters !== filters.length : false,
        inputProps: {
          "aria-label": "all items selected"
        }
      })
    },
    ListItemTextProps: {
      primary: "Select All",
      secondary: `${props.activeFilters}/${filters?.length} selected`
    },
    ContainerComponent: "div"
  }), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.filterListItemWrapper
  }, /*#__PURE__*/React.createElement(List, {
    className: classes.filterListItem,
    listItems: filterList
  })))));
};
export default SearchInputFilters;